import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import {useEffect, useRef, useState} from "react";


const UploadMatters = ({onUpload, count, formats = ["csv"]}) => {
    const [dragging, setDragging] = useState(false);
    const [message, setMessage] = useState({
        show: false,
        text: null,
        type: null
    });

    const drop = useRef(null);
    const drag = useRef(null);

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setDragging(false);

        // Here, Reading data from either drag or by clicking the upload component
        const files = e.dataTransfer
            ? [...e.dataTransfer.files]
            : [...e.target.files];

        // Count validation
        if (count && count < files.length) {
            showMessage(`Nope, only ${count} file${count !== 1 ? "s" : ""} can be uploaded at a time`, "error", 2000);
            return;
        }

        // Format validation
        if (formats && files.some(file => !formats.some(format => file.name.toLowerCase().endsWith(format.toLowerCase())))) {
            showMessage(`Only following file formats are acceptable: ${formats.join(", ")}`, "error", 2000);
            return;
        }

        // Calling the function passed from the parent
        if (files && files.length) {
            onUpload(files);
        }
    };

    const handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (e.target !== drag.current) {
            setDragging(true);
        }
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (e.target === drag.current) {
            setDragging(false);
        }
    };

    const showMessage = (text, type, timeout) => {
        setMessage({
            show: true,
            text,
            type
        });

        setTimeout(
            () =>
                setMessage({
                    show: false,
                    text: null,
                    type: null
                }),
            timeout
        );
    };
    //#endregion

    //#region for useEffect
    useEffect(() => {
        // Adding events
        const dropCurrent = drop.current;
        dropCurrent.addEventListener("dragover", handleDragOver);
        dropCurrent.addEventListener("drop", handleDrop);
        dropCurrent.addEventListener("dragenter", handleDragEnter);
        dropCurrent.addEventListener("dragleave", handleDragLeave);

        return () => {
            // Removing events
            dropCurrent.removeEventListener("dragover", handleDragOver);
            dropCurrent.removeEventListener("drop", handleDrop);
            dropCurrent.removeEventListener("dragenter", handleDragEnter);
            dropCurrent.removeEventListener("dragleave", handleDragLeave);
        };
    }, []);
    //#endregion

    return (
        <div className="drag-drop-matters" ref={drop}>
            {dragging && (
                <div className="drag-matters-wrapper" ref={drag}>
                    Drop Files Here...
                </div>
            )}
            {message.show && (
                <div
                    className={`FilesDragAndDrop__placeholder FilesDragAndDrop__placeholder--${message.type}`}
                >
                    {message.text}
                    <span role="img" aria-label="emoji" className="area__icon">
            {message.type === "error" ? <>&#128546;</> : <>&#128536;</>}
          </span>
                </div>
            )}
            <div className="drag-drop-matters__wrapper">
                <div className="upload-icon-wrapper">
                    <FileUploadOutlinedIcon
                        sx={{
                            color: "#8B8B8B",
                            fontSize: "40px"
                        }}
                    />
                </div>
                {/* <Button
          type="button"
          className="btn-orange"
          sx={{ width: "100%", maxWidth: "150px", mb: "10px" }}
          onChange={handleDrop}
        > */}
                <label htmlFor="file-input" style={{cursor: "pointer"}} className="btn btn-orange px-5 mb-1">
                    Add File
                    <input
                        id="file-input"
                        type="file"
                        className="d-none"
                        onChange={handleDrop}
                        accept=".csv"
                    />
                </label>
                {/* </Button> */}
                <p className="mb-0">or drop files to upload</p>
            </div>
        </div>
    );
};

export default UploadMatters;